
const allModules = {
  Dashboard: 'Dashboard',
  Profile: 'Profile',
  Setting: 'Setting',

  MedicalRooms: 'MedicalRooms',
  Training: 'Training',
  BioMedWaste: 'BioMedWaste',
  Laundry: 'Laundry',
  Equipment: 'Equipment',
  Handover: 'Handover',
  Inventory: 'Inventory',
  Sterlization: 'Sterlization',
  AmbulanceChecklist: 'AmbulanceChecklist',
  AmbulanceUtilization: 'AmbulanceUtilization',
  FirstAid: 'FirstAid',
  Opd: 'Opd',
} as const;

export type ModuleName = keyof typeof allModules;
export default allModules;
